import React, { useEffect, useState } from 'react'
import Layout from '../../components/layout_user'
import { useSelector, useDispatch } from 'react-redux'
import {
  FlexEnd,
  Summary,
  BoxForRadio,
  Total, Container,
  ButtonContainer,
  Notify,
  IconContainer
} from './styled'
import Item from './compoenents/item'
import { updateQuantity, RemoveItem } from '../../../flux/cart'
import { setAlert } from '../../../flux/alert'
import Currency from '../../../helpers/currency'
import sumePrice from '../../../helpers/sumPrice'
import Empty from '../../components/empty'
import { taxPorcent } from '../../../config'
import { useMediaQuery, Button, Box, Grid, Checkbox } from '@material-ui/core'
import { useHistory } from 'react-router-dom'
import useShippingCost from '../../../hooks/useShippingCost'
import styled from 'styled-components'
import { Alert } from '@material-ui/lab'

const CheckboxStyled = styled(Checkbox)`
  padding: 0px;
  padding-left: 15px;
  margin-right: 0px!important;
  span {
    color: var(--first);
  }
`

const MyCart = props => {
  var shippingCost = useShippingCost()
  const [address, setAddress] = useState(null)
  const [error, setError] = useState(false)

  shippingCost = address ? shippingCost : 0
  const myCart = useSelector(state => state.cart)
  const dispatch = useDispatch()
  const subtotal = sumePrice(myCart)
  const discountPercentage = 0.1 // Discount for online shopping
  const discountAmount = subtotal * discountPercentage
  const tax = Math.ceil((subtotal + shippingCost) * (taxPorcent / 100))
  const total = subtotal - discountAmount + shippingCost + tax
  const history = useHistory()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  // save shipping option to localstorage
  useEffect(() => {
    window.localStorage.setItem('address', address)
  }, [address])

  const isMobile = useMediaQuery('(max-width:600px)')

  const handleRemoveItem = data => {
    dispatch(
      setAlert({
        title: 'Atención ',
        message: '¿Estas seguro de quitar este estudio de tu carrito?',
        action: RemoveItem(data.id)
      })
    )
  }

  const handleChangeQuantity = (item, quantity) => {
    if (quantity === 0) return false
    dispatch(updateQuantity({
      id: item.id,
      quantity
    }))
  }

  // hidde error when shipping option selected
  useEffect(() => {
    if (address !== null) setError(false)
  }, [address])

  const handleNext = event => {
    if (address === null) return setError(true)
    history.push('/checkout')
  }

  return (
    <Layout>
      {!!myCart.length && (
        <Container style={{ marginTop: '50px' }}>
          <Item header />
          {myCart.map(item => (
            <Item
              handleRemoveItem={handleRemoveItem}
              handleChangeQuantity={handleChangeQuantity}
              key={item.id}
              {...item}
            />
          ))}

          <FlexEnd>
            <Notify>
              <IconContainer>%</IconContainer>
              ¡Recibe un 10% de descuento por compra en línea!
            </Notify>
          </FlexEnd>
          <Box mt={2} />

          <FlexEnd>
            <Summary>
              <div>
                <span>Subtotal:</span>
                $ {Currency.formatMoney(subtotal)}
              </div>
              <div>
                <span>Descuento por compra en línea:</span>
                $ -{Currency.formatMoney(discountAmount)} (10%)
              </div>
              <div>
                <span>Toma a domicilio:</span>
                $ {Currency.formatMoney(shippingCost)}
              </div>
              {!!tax && (
                <div>
                  <span>IVA:</span>
                  $ {Currency.formatMoney(tax)}
                </div>
              )}
            </Summary>
          </FlexEnd>

          <FlexEnd>
            <Total>
              <div>
                <span style={{ color: 'var(--first)' }}>Total:</span>
                $ {Currency.formatMoney(total)}
              </div>
            </Total>
          </FlexEnd>
          <Box mt={2} />

          <FlexEnd>
            <BoxForRadio>
              <Grid container>
                <Grid item xs={2}> <CheckboxStyled color='primary' checked={address === true} onClick={event => setAddress(true)} /></Grid>
                <Grid item xs>
                  <div>
                    <div>Toma a Domicilio</div>
                    <span>
                      Servicio proporcionado únicamente en zona conurbada de la ciudad de Querétaro, Qro.
                    </span>
                  </div>
                </Grid>
              </Grid>
            </BoxForRadio>
          </FlexEnd>

          <Box mt={2} />
          <FlexEnd>
            <BoxForRadio>
              <Grid container>
                <Grid item xs={2}> <CheckboxStyled color='primary' checked={address === false} onClick={event => setAddress(false)} /></Grid>
                <Grid item xs>
                  Toma en sucursal
                </Grid>
              </Grid>
            </BoxForRadio>
          </FlexEnd>

          {error && (
            <FlexEnd>
              <BoxForRadio style={{ border: 'none', padding: '0px', marginTop: '10px' }}>
                <Alert severity='error'>Debes seleccionar alguna de las opciones para la toma de tu muestra.</Alert>
              </BoxForRadio>
            </FlexEnd>
          )}
          <ButtonContainer>
            <Button size={isMobile ? 'small' : 'large'} style={{ width: '50%', maxWidth: '220px', minWidth: '150px', fontSize: isMobile ? '.9em' : '1em', marginRight: '15px' }} onClick={() => history.push('/')} color='primary' variant='outlined'>{isMobile ? 'Volver' : 'Seguir comprando'}</Button>
            <Button size={isMobile ? 'small' : 'large'} style={{ width: '50%', maxWidth: '220px', minWidth: '150px', fontSize: isMobile ? '.9em' : '1em' }} onClick={handleNext} color='primary' variant='contained'>Continuar</Button>
          </ButtonContainer>
        </Container>
      )}
      {!myCart.length && (
        <Container>
          <Empty />
        </Container>
      )}
    </Layout>
  )
}

export default MyCart
